<div [ngStyle]="{'width':imgContainerWidth?imgContainerWidth:'none'}">
    <img 
    class="twodthreed-home-img"
    [src]="imgsrc" 
    alt="game-card-image" 
    style="width: 100% !important;cursor: pointer !important;border: 1px solid #F12319;border-radius: 5px;"
    [ngStyle]="{'height':imgHeight?imgHeight:'none'}">
</div>